const TeamcenterPlmCourse = {
    id: "teamcenter-plm",

    name: "Teamcenter PLM Customization",
syllabusPdf: "/syllabus/TC-PLM-Syllabus.pdf",

    hero: {
        title: "Teamcenter PLM Customization",
        subtitle: "Live & Interactive Online Training",
        logo: "/teamcenter-plm-logo.webp",

        points: [
            "Master Teamcenter PLM Customization and Integration using C++ and ITK. Learn to automate engineering workflows, customize business logic, and extend core PLM functionalities in enterprise-grade environments.",

            "Ideal for C++ developers, mechanical engineers, and PLM analysts aiming for high-paying roles in product lifecycle management, enterprise system automation, and smart manufacturing.",

            "Advance your career from traditional engineering to core PLM backend development by mastering customization of Business Objects, user exits, handlers, and integrations — all through C++ and the Teamcenter ITK.",

            "Start from scratch — no prior Teamcenter experience required. We guide you from C++ fundamentals to full-scale customization of BOMs, workflows, data models, and security rules.",

            "Learn from experienced Teamcenter professionals working in global companies and get hands-on mentorship on deploying and supporting real-time PLM solutions used in aerospace, automotive, and manufacturing."
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "“For Teamcenter Design Engineers with 4 to 5 years of experience, the average CTC ranges from 5 Lakhs to 10 Lakhs. However, Teamcenter Developers with the same experience can command CTCs of 20 Lakhs to 30 Lakhs.”"
        },
        {
            title: "Good Demand",
            description:
                "“While Teamcenter Design is a well-known skill among mechanical engineers, there is intense competition for design jobs. On the other hand, Teamcenter Automation & Customization is a niche expertise, with only a few engineers.”"
        },
        {
            title: "Easier To Learn",
            description:
                "“While Teamcenter Design is generally easier to learn, Autodesk inventor Automation & Customization can be more challenging. With our extensive experience in this field, we aim to simplify the process for you with our step by step training.”"
        }
    ],

    whyLearn: [
        {
            title: "Work with the World’s Leading PLM Platform",
            description:
                "Teamcenter by Siemens is one of the most widely used PLM systems globally in industries like automotive, aerospace, defense, and industrial machinery."
        },
        {
            title: "High Demand in Top Industries",
            description:
                "Companies like Boeing, Airbus, Ford, GE, Tata, and Siemens actively seek professionals skilled in Teamcenter customization — offering high-paying, long-term career opportunities."
        },
        {
            title: "Enable Enterprise-Scale Automation",
            description:
                "Customization allows companies to automate engineering workflows, product configurations, document management, and lifecycle operations at scale."
        },
        {
            title: "Master Server- and Client-Side Development",
            description:
                "With Teamcenter, you’ll learn both server-side (ITK, C++) and client-side (RAC, Java) customizations — giving you a full-stack enterprise development profile."
        },
        {
            title: "Build Custom Business Logic and Rules",
            description:
                "You’ll be able to implement custom handlers, pre/post actions, validations, and workflow extensions — tailoring Teamcenter to specific business needs."
        },
        {
            title: "Integrate with CAD, ERP, and MES Systems",
            description:
                "Teamcenter customization enables seamless integration with tools like NX, SolidWorks, SAP, Oracle ERP, and MES systems, creating full digital threads."
        },
        {
            title: "Master Tools like BMIDE, SOA, and XML",
            description:
                "BMIDE for data modeling\n\nSOA for service development\n\nTeamcenter XML for data import/export and integrations"
        },
        {
            title: "Accelerate Digital Transformation Projects",
            description:
                "Customization plays a key role in implementing Industry 4.0, digital twin, and model-based engineering initiatives inside manufacturing organizations."
        },
        {
            title: "Career Growth Beyond Traditional Engineering",
            description:
                "PLM Solution Architect\n\nDigital Thread Consultant\n\nPLM Integration Engineer\n\nTechnical Project Lead"
        },
        {
            title: "Future-Proof Your Career",
            description:
                "As global industries shift toward data-driven product development, professionals who can customize and extend PLM systems like Teamcenter will stay in high demand for years to come."
        }
    ],

 syllabus: [
    {
        name: "C++",
        modules: [
            {
                number: 1,
                title: "Basic C++ Concepts",
                topics: [
                    "Introduction to C++",
                    "Understanding OOP Basics",
                    "Basic Syntax and Program Structure",
                    "Data Types and Modifiers",
                    "Declaring and Using Variables",
                    "Operators in C++",
                    "sizeof and typedef Usage",
                    "Decision Making (if, else, switch)",
                    "Loop Types (for, while, do-while)",
                    "Storage Classes (auto, static, register, extern)",
                    "Functions and Scope"
                ]
            },
            {
                number: 2,
                title: "Object-Oriented Programming (OOP)",
                topics: [
                    "Classes and Objects",
                    "Access Specifiers (public, private, protected)",
                    "Defining Classes & Creating Objects",
                    "Accessing Data Members & Member Functions",
                    "Types of Member Functions",
                    "Inline Functions",
                    "Function Overloading",
                    "Constructors and Destructors",
                    "Initializer Lists",
                    "Namespaces",
                    "static and const Keywords",
                    "References in C++",
                    "Copy Constructors",
                    "Pointers to Members"
                ]
            },
            {
                number: 3,
                title: "Advanced C++ Concepts",
                topics: [
                    "Introduction to Inheritance",
                    "Types of Inheritance (Single, Multiple, Multilevel, Hybrid)",
                    "Order of Constructor and Destructor Calls",
                    "Upcasting",
                    "Function Overriding",
                    "Virtual Functions",
                    "Abstract Classes & Pure Virtual Functions",
                    "Virtual Destructors",
                    "Operator Overloading",
                    "File Streams (ifstream, ofstream, fstream)",
                    "Exception Handling Basics",
                    "Memory Management (new, delete)",
                    "Introduction to Multithreading"
                ]
            },
            {
                number: 4,
                title: "C++ Miscellaneous Concepts",
                topics: [
                    "Namespaces in Practice",
                    "C++ String Handling",
                    "Advanced Exception Handling",
                    "Try-Catch Blocks",
                    "User-Defined Data Types",
                    "Templates (Function and Class Templates)",
                    "Signal Handling in C++",
                    "File and Stream Management",
                    "Using getline() for Input"
                ]
            }
        ]
    },

    {
        name: "Teamcenter PLM",
        modules: [
            {
                number: 1,
                title: "Teamcenter Administration",
                topics: [
                    "Introduction to Teamcenter Administration",
                    "Managing Preferences",
                    "Organization Management",
                    "Access Manager (ACL Tree)",
                    "Project-Based Access Control",
                    "Structure Manager & Revision Rules",
                    "Query Builder Definitions",
                    "Workflow Process Modeling",
                    "Workflow Templates",
                    "Report Builder Definitions",
                    "Using Utilities & Admin Tools",
                    "Command Suppression Techniques",
                    "Authorization Management"
                ]
            },
            {
                number: 2,
                title: "Teamcenter Configuration – Data Model (BMIDE)",
                topics: [
                    "Introduction to BMIDE Administration",
                    "Business Modeler IDE Fundamentals",
                    "Naming Rules & Conventions",
                    "Item BO Configuration",
                    "Form BO Configuration",
                    "Dataset BO Configuration",
                    "Relation BO Configuration",
                    "Creating & Managing Properties",
                    "Global Constants",
                    "Conditions Configuration",
                    "BOMLine BO Configuration",
                    "LOV (List of Values) Extensions",
                    "NoteType and UOM Configuration",
                    "Option Extensions",
                    "Rules Configuration (GRM, Display, Deep Copy Rules)",
                    "Working with Packaged Templates"
                ]
            },
            {
                number: 3,
                title: "Teamcenter Customization – ITK (C++)",
                topics: [
                    "Introduction to Customization through Coding",
                    "Teamcenter Environment Setup for ITK",
                    "Overview of ITK Programming",
                    "Understanding Teamcenter API Functions",
                    "Basics of Batch Programs",
                    "Query-Based Batch Programs",
                    "Folder Manipulation",
                    "Item Creation & Updates",
                    "Reading Property Values Programmatically",
                    "User Exit Basics & Custom User Exits",
                    "Creating Custom Handlers (with Practical Examples)",
                    "Integrating Handlers into New Workflows",
                    "Building and Deploying OOTB Library Exits"
                ]
            },
            {
                number: 4,
                title: "Teamcenter Customization – RAC (Rich Client)",
                topics: [
                    "Introduction to Rich Client Customization",
                    "Non-Programming Based Customization",
                    "UI Form Introduction",
                    "UI Forms with JavaBeans",
                    "UI Forms using XML Stylesheets",
                    "Developing New Rich Client Applications",
                    "Extending RAC with OOTB Commands"
                ]
            },
            {
                number: 5,
                title: "Teamcenter Customization – SOA (Service-Oriented Architecture)",
                topics: [
                    "Introduction to OOTB SOA Services",
                    "Workshop with soa_client.zip (Calling OOTB Services)",
                    "When & Why to Author Custom SOA Services",
                    "Overview of Custom SOA Development",
                    "Hands-on: Authoring a New SOA Service"
                ]
            }
        ]
    }
],

    faq: [
        {
            question: "What is Teamcenter PLM?",
            answer:
                "Teamcenter PLM (Product Lifecycle Management) is a comprehensive software suite by Siemens that helps organizations manage the entire lifecycle of their products, from concept and design to manufacturing, servicing, and retirement. It provides tools for collaboration, data management, workflow automation, and more, ensuring seamless product development and improved decision-making throughout the product’s lifecycle."
        },
        {
            question: "How do CAA Developers command higher salaries?",
            answer:
                "CAA Developers often receive significantly higher salaries compared to CATIA 3D designers. This is because they create automation tools that can perform tasks that would be challenging for many individuals to accomplish without such tools.\n\nFor a detailed explanation, please view the video located at this page."
        },
        {
            question:
                "I have CAD design experience; will it be beneficial for me in CAD Automation & Customization?",
            answer:
                "Absolutely, having CAD design experience is an advantage. It allows you to fully leverage your design skills and familiarity with CAD tools.\n\nYou can adeptly assess and make informed decisions about which aspects to automate and the value that automation brings.\n\nIn the future, your background can position you to lead teams of both design engineers and developers, bridging the gap between design excellence and cutting-edge automation solutions."
        },
        {
            question: "Can I work on all CAD Customization if I learn one?",
            answer:
                "Yes and No.\n\nIn the first part of the training, you’ll grasp programming concepts that are foundational for all CAD customizations, creating a strong common foundation.\n\nHowever, the CAD API knowledge gained in the second part of the training is tool-specific, tailored to a particular CAD software.\n\nTo work on various CAD customizations, you would need to familiarize yourself with the APIs specific to each tool. Yet, if you master one API thoroughly, you’ll find it relatively straightforward to adapt and learn others independently with minimal effort."
        },
        {
            question:
                "Why should I choose FeesWorth for learning CAD Automation and Customization?",
            answer:
                "When it comes to CAD Automation or Customization, FeesWorth is the most experienced institute, with over a decade of expertise in providing this training.\n\nWe have a unique ability to teach programming to Mechanical Engineers and CAD to software developers, making our training accessible to a diverse audience.\n\nOur success stories and proven track record demonstrate the effectiveness of our approach, ensuring you receive the best education in CAD Automation and Customization."
        },
        {
            question: "Is job guarantee provided with the courses?",
            answer:
                "No, job guarantee is not provided with this course, but job assistance is provided. This is because securing a job largely depends on your personal abilities and the effort you invest in practicing your CAD skills."
        },
        {
            question: "Which programming language is suitable for CAD Customization?",
            answer:
                "For CATIA CAA Customization and Creo Toolkit Customization, C++ is an excellent choice.\n\nFor other CAD tools such as NX, AutoCAD, Solidworks, Inventor, etc., C#.NET or VB.NET are well-suited programming languages."
        },
        {
            question: "What are the current job opportunities in this field?",
            answer:
                "This skill is quite rare, with a limited number of professionals available in the market compared to the growing demand. Consequently, the job opportunities in this field are in high demand and offer promising prospects."
        }
    ],

    videos: [
        {
            category: "What is CAD Customization? (Explained using real project)",
            title: "CAD Customization And Automation Session",
            videoUrl:
                "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=1\\&forigin=https%3A%2F%2Ffeesworth.com%2Fteamcenter-plm-customization-training-itk-rac-soa-awc%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2F\\&vf=1"
        },
        {
            category: "Real first Day programming class",
            title: "Day 1: Programming Class C#.NET",
            videoUrl:
                "https://www.youtube.com/embed/7U2z7LUMH9g?controls=1\\&rel=0\\&playsinline=0\\&cc_load_policy=0\\&autoplay=0\\&enablejsapi=1\\&origin=https%3A%2F%2Ffeesworth.com\\&widgetid=3\\&forigin=https%3A%2F%2Ffeesworth.com%2Fteamcenter-plm-customization-training-itk-rac-soa-awc%2F\\&aoriginsup=1\\&gporigin=https%3A%2F%2Ffeesworth.com%2F\\&vf=1"
        }
    ]
};

export default TeamcenterPlmCourse;